/* @flow */

import { em } from 'polished';

import { antialiasing } from 'src/shared/app/base/style/token/helper';
import { headlineFontSize } from '@e180/ui/lib/token/typography';

export default {
  root: {
    extend: antialiasing,

    margin: [em(12, headlineFontSize), 0, em(8, headlineFontSize)],

    textAlign: 'center',
  },
};
